import { useInfiniteQuery, UseInfiniteQueryOptions } from '@tanstack/react-query';
import { SnackbarStatus, useSnackbar } from '@weareopenr/component-library';
import type { TMenuItemType } from 'src/types/menu.types';
import { QueryKeys } from 'src/hooks/QueryKeys';
import { getProductSizedItems } from 'src/api/getProductSizedItems/getProductSizedItems';
import { ProductSizedItemsResponseBody } from 'src/api/getProductSizedItems/types';
import { getBrandId } from 'src/helpers/getBrandId/getBrandId';
import { parseQueryParamsFromRelativeUrlPath } from 'src/helpers';

interface useProductLibraryItemsOptions {
  searchQuery?: string;
  limit?: number;
  type?: TMenuItemType[];
  options?: UseInfiniteQueryOptions<ProductSizedItemsResponseBody>;
  ranges?: string[];
}

export const useProductLibraryItems = ({
  searchQuery,
  limit = 50,
  type,
  options,
  ranges,
}: useProductLibraryItemsOptions) => {
  const { showSnackbar } = useSnackbar();

  return useInfiniteQuery<ProductSizedItemsResponseBody>({
    queryKey: [QueryKeys.productSizes, getBrandId(), searchQuery, type, ranges],
    queryFn: ({ pageParam }) => getProductSizedItems(pageParam, searchQuery, limit, type, ranges),
    getNextPageParam: (lastPage) => {
      const nextPageUrlPath = lastPage?.paging?.next;

      if (!nextPageUrlPath) return null;

      return parseQueryParamsFromRelativeUrlPath(nextPageUrlPath).get('after_id');
    },
    refetchOnWindowFocus: false,
    onError: () => showSnackbar({ status: SnackbarStatus.ERROR, message: 'Internal Server Error' }),
    ...options,
  });
};

export default useProductLibraryItems;
